var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.361,
    height: 26.361,
    viewBox: "0 0 26.361 26.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_944",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 944",
    transform: "translate(-738.346 -2797.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-linkedin-5",
    d: "M1767.513,1753.678a1.1,1.1,0,1,1,0-.009Zm0,2.2h-2.2v6.59h2.2Zm3.3,0h-2.2v6.59h2.2v-3.142c0-1.891,2.2-2.066,2.2,0v3.142h2.2v-3.69c0-3.607-3.436-3.475-4.394-1.7Z",
    transform: "translate(-1018.183 1052.903)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_4",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 4",
    transform: "translate(738.346 2797.794)",
    fill: "none",
    stroke: "#d19f46",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.181,
    cy: 13.181,
    r: 13.181,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.181,
    cy: 13.181,
    r: 12.681,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIn);
export default __webpack_public_path__ + "static/media/icon_in.0072cc77f34c844a0c1dd63a3db32e25.svg";
export { ForwardRef as ReactComponent };